// This file can be deleted since none of its styled components are being used.
// All the styling is being handled by the CustomTable component.

import { styled } from '@mui/material/styles';
import { CardContent } from '@mui/material';
import { alpha } from '@mui/material/styles';

export const StyledCardContent = styled(CardContent)(({ theme }) => ({
  backgroundColor: theme.palette.mode === 'dark'
    ? alpha(theme.palette.background.default, 0.85)  // Reduced alpha for more transparency
    : '#f3f4fb',  // Lighter purple background (#e9eaf7 made lighter)
  minHeight: 'calc(100vh - 88px)',  // Adjusted for header height
  padding: theme.spacing(3),
  margin: 0,
  transition: 'background-color 0.3s ease',
  '& .MuiPaper-root': {
    backgroundColor: theme.palette.mode === 'dark'
      ? theme.palette.background.paper
      : '#FFFFFF',
    borderRadius: theme.shape.borderRadius,
    boxShadow: theme.palette.mode === 'dark'
      ? '0 4px 20px 0 rgba(0,0,0,0.4)'
      : '0 2px 10px 0 rgba(58,53,65,0.1)',
  },
  '&.MuiCardContent-root': {
    padding: theme.spacing(3),
    '&:last-child': {
      paddingBottom: theme.spacing(3)
    }
  },
  // Remove padding from the top level CardContent
  padding: 0,
  '&:last-child': {
    paddingBottom: 0
  }
}));
